<div id="services_filterpanel_control" [ngClass]="{'zsd-cust-filter-filtermenu-lg':windowSize >= 992}" class="zsd-cust-filter-filtermenu">

    <button class="btn zsd-cust-filter-button  zsd-cust-filter-filtermenu-closebtn d-block d-xl-none d-lg-none"  (click)="closeFilter()">
        <span class="fa fa-arrow-left fa-lg"></span>
    </button>
    
	<div class="card" id="zsd_cust_filter_panel">
        <div class="card-body pb-0">
            <!-- Adding Filter as title at the top of the Filter-->
			<div class="card-title" id="zsd_cust_filter_text"><em class="fa fa-filter custom-filter"></em>{{'CommonStrings.filter' | translate}}</div>
        </div>
 
	 <!-- Category -->
	 <div class="card-body">
			 <div class="card-title" id="zsd_cust_filter_category" data-toggle="collapse" data-target="#sd_items_category">
				 {{ 'CommonStrings.itemCategoryHeader' | translate  }}
			 </div>
			 <div id="sd_items_category" class="collapse show">
			 <div class="search">
				 <input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'CommonStrings.search' | translate  }}"  [(ngModel)]="searchCategory" autocomplete="off">
			 </div>
 
			 <div id="zsd_cust_filter_category_list">
				 <div class="form-check" *ngFor="let category of categoryResults | searchFilterPipe:'categoryName':searchCategory">
					 <label class="form-check-label" for="{{category.categoryName}}">
						 <input type="checkbox" class="form-check-input" value="category" id="{{category.categoryName}}" [(ngModel)]="category.checked">{{category.categoryName}}
					 </label>
				 </div>
			 </div>
			 </div>
		 </div>
		 
 
 
			 <!-- Item Types -->
		 <div class="card-body zsd-cust-filter-bottom-line">
				 <div class="card-title" id="zsd_cust_filter_item_types" data-toggle="collapse" data-target="#sd_item_types" [class.collapsed]="!itemTypeChecked">
					 {{ 'CommonStrings.itemTypesHeader' | translate   }}
				 </div>
				 <div id="sd_item_types" [className]="itemTypeChecked ? 'collpase show' : 'collapse'">
				 <div class="search">
					 <input type="text" class="form-control" type="search" id="zsd_cust_filter_placeholder_search" placeholder="{{ 'CommonStrings.search' | translate  }}" [(ngModel)]="searchItemType" autocomplete="off">
				 </div>
				 <div id="zsd_cust_filter_item_types_list">
					 <div class="form-check" *ngFor="let itemType of itemTypesResults | searchFilterPipe: 'itemTypeName':searchItemType">
						 <label class="form-check-label" for="{{itemType.itemTypeName}}">
							 <input type="checkbox" class="form-check-input" value="itemType" id="{{itemType.itemTypeName}}" [(ngModel)]="itemType.checked">{{itemType.itemTypeName}}
						 </label>
					 </div>
				 </div>
				 </div>
	 
			 </div>
	 
	 
			 <div class="form-group text-center" id="zsd_cust_filter_button_id">
				 <button type="submit" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_apply" (click)="applyFilter()">{{ 'CommonStrings.applyButton' | translate   }}</button>
				 <button type="button" class="btn zsd-cust-filter-button" id="zsd_cust_filter_button_clear" (click)="clearFilter()">{{ 'CommonStrings.clearButton' | translate   }}</button>
			 </div>
	 
 
	</div>
 </div>